import { Text } from '@epam/promo';
import { StatisticsDataProps } from './StatisticsData.model';
import css from './StatisticsData.module.scss';

export const StatisticsData = ({ title, value }: StatisticsDataProps) => (
  <div className={`${css['statistics-data__container']} ${css[title]}`}>
    <div className={css['statistics-data__text']}>
      <Text color="gray60" size="30">
        {title}
      </Text>
      <Text cx={css['statistics-data__value']}>{value}</Text>
    </div>
  </div>
);
